export default "__VITE_ASSET__969cd697__"